<template>
  <div class="content">
    <div class="top">
      <img style="width: 45%; height: auto" :src="logo" />
    </div>
    <div class="sign">
      <div v-show="loginType !== '3' && isEsign">
        <van-radio-group
          v-model="loginType"
          @change="loginTypeChange"
          direction="horizontal"
        >
          <van-radio name="1">用户账户</van-radio>
          <van-radio name="2">统一身份认证账户</van-radio>
        </van-radio-group>
      </div>
      <div class="signdiv" :class="{ focus1: telFocus }">
        <van-field
          v-model="userName"
          :type="loginType === '3' ? 'number' : 'text'"
          maxlength="30"
          :placeholder="userholder"
          clearable
          @focus="getFocus(1)"
          @blur="onblur(1)"
        >
        </van-field>
      </div>
      <div class="signdiv password" :class="{ focus1: verifyFocus }">
        <div class="display_inline_block" style="width: 60%">
          <van-field
            type="number"
            :placeholder="verifyholder"
            v-model="verifyCode"
            @focus="getFocus(2)"
            @blur="onblur(2)"
            maxlength="6"
            clearable
          >
          </van-field>
        </div>
        <span
          @click="getPictureImg()"
          class="display_inline_block"
          title="看不清,换一个"
          style="width: 35%"
        >
          <img
            :src="verifyImg"
            style="height: 2rem; width: 5rem"
            fill
            title="看不清,换一个"
        /></span>
      </div>
      <div class="signdiv password" :class="{ focus1: codeFocus }">
        <div
          class="display_inline_block"
          :style="{ width: loginType === '3' ? '60%' : '100%' }"
        >
          <van-field
            :type="loginType === '3' ? 'number' : passwordType"
            :placeholder="passwordholder"
            v-model="password"
            @focus="getFocus(3)"
            @blur="onblur(3)"
            :maxlength="loginType === '3' ? '6' : '30'"
            clearable
            @clear="clearPassword()"
            @keydown.enter="dlu()"
          >
            <template
              v-if="loginType !== '3' && password.length > 0"
              slot="right-icon"
            >
              <img
                style="width: 20px; object-fit: contain; margin-top: 5px"
                :src="passwordType === 'password' ? showPass : hidePass"
                @click="switchPasswordType()"
              />
            </template>
          </van-field>
        </div>
        <span
          v-if="loginType === '3'"
          @click="checkCode()"
          class="display_inline_block text14 all_text_right all_line_height20"
          style="width: 35%"
          :class="{ textcolormain: timer === 60, textcolor999: timer != 60 }"
        >
          {{ timer === 60 ? "获取验证码" : timer + "s后再次获取" }}</span
        >
      </div>
      <div class="margin_top_5" style="position: relative; height: 1rem">
        <span class="forgot text12" @click="forgot()">忘记密码</span>
      </div>
      <div class="text14 margin_top_5" style="text-align: left">
        <div class="display_inline_block" style="width: auto">
          <van-checkbox v-model="checked"></van-checkbox>
        </div>
        我已阅读并同意
        <span
          class="textcolormain"
          style="line-height: 1.2rem"
          @click="agreementUserClick()"
          >《用户协议》</span
        >与<span
          class="textcolormain"
          style="line-height: 1.2rem"
          @click="agreementPrivacyClick()"
          >《隐私政策声明》</span
        >
      </div>
      <button id="bottom" class="dlu text14" @click="dlu()">
        登&nbsp;&nbsp;录
      </button>
    </div>
    <div class="buttonBottom">
      <span class="left text12" @click="changeLoginType()">{{
        loginType === "3" ? "密码登录" : "验证码登录"
      }}</span>
      <span v-show="isEsign" class="right text12" @click="register()"
        >立即注册</span
      >
    </div>
    <div style="flex: 1"></div>
    <div
      class="text12 textcolor33 all_text_center all_height20"
      style="padding: 0 10%; margin-bottom: 1rem"
    >
      <div>Copyright © 2025中国石油化工集团有限公司版权所有</div>
      <div>京ICP备05037230号-83A 运维电话:4009199000转3</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Checkbox,
  Field,
  RadioGroup,
  Radio
} from 'vant';
import {
  test,
  testActivity
} from '../../utils/nativeTestDemo.js'
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      //验证码倒计时
      timer: 60,
      //账户名、统一身份账号、手机号
      userName: '',
      //密码、验证码
      password: '',
      //图片验证结果
      verifyCode: '',
      //验证Id
      verifyId: '',
      //验证图片
      verifyImg: '',
      telFocus: false,
      verifyFocus: false,
      codeFocus: false,
      //选中协议
      checked: false,
      //1注册账户登录 2统一身份登录,3 验证码登录,
      loginType: '1',
      //密码是否显示
      passwordType: 'password',
      //默认显示
      userholder: '用户账号',
      //默认显示
      passwordholder: '登录密码',
      //默认显示
      verifyholder: '计算结果',
      //显示
      showPass: require('../../assets/images/show_password.svg'),
      //隐藏
      hidePass: require('../../assets/images/hide_password.svg'),
      //屏幕高度
      height: 0,
      //
      isEsign: process.env.VUE_APP_PROJECT_OWNER === 'esign',
      //
      logo: process.env.VUE_APP_PROJECT_OWNER === 'zhlh' ? require('@/assets/images/logo_new.png') : require(
        '@/assets/images/logo.png')
    };
  },
  mounted() {
    this.init()
  },
  computed: {
    //获得高度
    resize() {
      if (this.height === 0) {
        this.height = document.body.clientHeight
      }
    },
  },
  beforeDestroy() { },
  created() { },
  methods: {
    //初始化
    init() {
      // const files = this.$route.query.files
      // this.$Toast('刷新进入登录页'+files)
      this.getPictureImg()
      //this.test()
      //this.testActivity()
    },
    // test(){
    // 	let a = '12345678.\,12312455'
    // 	let b = a.replace('\\','')
    // 	console.log('test',a,b)
    // },
    //监听高度变化做相应的操作
    makeResize() {
      //键盘弹出
      if (this.height > 0 && document.body.clientHeight < this.height) {
        // console.log('执行可见',document.body.clientHeight)
        // let b = document.getElementById('bottom')
        // b.scrollIntoView()
        document.getElementById('icp').style.display = 'none'
      }
      if (this.height > 0 && document.body.clientHeight == this.height) {
        //console.log('makeResize等于执行')
      }
    },
    //用户协议
    agreementUserClick() {
      //this.$Toast("用户协议！");
      let names = 'agreementdetails'
      if (!this.isEsign) {
        names = 'agreement'
      }
      this.$router.push({
        name: names,
        params: {
          type: 1,
        }
      })
    },
    //隐私政策
    agreementPrivacyClick() {
      //this.$Toast("隐私政策！");
      let names = 'agreementdetails'
      if (!this.isEsign) {
        names = 'agreement'
      }
      this.$router.push({
        name: names,
        params: {
          type: 2,
        }
      })
    },
    //跳转
    go(id) {
      this.$router.push(id);
    },
    //替换
    replace(id) {
      this.$router.replace(id)
    },
    //
    loginTypeChange(value) {
      this.userName = ''
      this.password = ''
      this.verifyCode = ''
      if (value === '2') {
        this.userholder = '统一身份认证账号'
      } else if (value === '1') {
        this.userholder = '用户账号'
      } else {
        this.userholder = '手机号'
      }
      this.getPictureImg()
    },
    // 清空密码
    clearPassword() {
      if (this.loginType !== '3') {
        this.passwordType = 'password'
      }
    },
    // 切换密码类型
    switchPasswordType() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    // 获得焦点
    getFocus(id) {
      if (id == 1) {
        this.telFocus = true;
      } else if (id == 2) {
        this.verifyFocus = true;
      } else if (id == 3) {
        this.codeFocus = true;
      }
    },
    // 失去焦点
    onblur(id) {
      if (id == 1) {
        this.telFocus = false;
      } else if (id == 2) {
        this.verifyFocus = false;
      } else if (id == 3) {
        this.codeFocus = false;
      }
      //console.log('onblur', id)
    },
    //改变登录类型
    changeLoginType() {
      if (this.loginType === '3') {
        this.userholder = '用户账号'
        this.passwordholder = '登录密码'
        this.userName = ''
        this.password = ''
        this.verifyCode = ''
        this.loginType = '1';
      } else {
        this.userholder = '手机号'
        this.passwordholder = '验证码'
        this.timer = 60
        this.userName = ''
        this.password = ''
        this.verifyCode = ''
        this.loginType = '3';
      }
      this.getPictureImg()
    },
    //获取认证图片
    getPictureImg() {
      this.verifyCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/login/api/getPictureImg').then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.verifyId = res.data.verifyId
          this.verifyImg = res.data.srcImg
        } else {
          this.verifyImg = ''
          this.$Toast("未获取到验证图片！")
        }
      }).catch((err) => {
        this.verifyImg = ''
        this.$store.dispatch(this.$LoadShow, false)
        console.log('getPictureImg', err)
      });
    },
    //核验手机号
    checkCode() {
      if (this.timer != 60) {
        return
      }
      this.userName = this.userName.trim()
      let reg = /^1[0-9]{10}$/;
      if (
        this.userName &&
        this.userName.length == 11 &&
        reg.test(this.userName)
      ) {
        if (!this.verifyId || !this.verifyCode) {
          this.$Toast("请输入图片验证码计算结果！");
          return
        }
        this.password = "";
        this.$store.dispatch(this.$LoadShow, true)
        this.$post("/login/api/smsLoginCheck", JSON.stringify({
          mobile: this.userName
        })).then((res) => {
          if (res.success) {
            this.getCode()
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast(res.message || res.messageDetail || "获取验证码失败！")
          }
        }).catch((err) => {
          this.$store.dispatch(this.$LoadShow, false)
          console.log('smsLoginCheck', err)
        });
      } else {
        this.$Toast("请输入正确的手机号！")
      }
    },
    // 获取验证码
    getCode() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$post("/login/api/sendSmsCode", JSON.stringify({
        mobile: this.userName,
        type: 1, //type：1 登录、2 忘记密码、3 重置密码、4 更换手机号 5、个人认证
        verify: {
          id: this.verifyId,
          code: this.verifyCode
        }
      })).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          this.$Toast("验证码已发送，请注意查收！");
          this.timer--;
          var timer1 = setInterval(() => {
            this.timer--;
            if (this.timer == 0) {
              this.timer = 60;
              clearTimeout(timer1);
            }
          }, 1000);
        } else {
          this.getPictureImg()
          this.$Toast(res.message || "获取验证码失败！")
        }
      }).catch((err) => {
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
        console.log('sendSmsCode', err)
      });
    },
    //登录
    dlu() {
      if (!this.checked) {
        this.$Toast("请勾选用户协议！");
        return
      }
      this.userName = this.userName.trim()
      this.password = this.password.trim()
      switch (this.loginType) {
        //账户登录，统一账户登录
        case '1':
        case '2':
          //密码登录
          if (!this.userName) {
            this.$Toast("请输入账户！");
            return
          }
          if (!this.verifyId || !this.verifyCode) {
            this.$Toast("请输入图片验证码！");
            return
          }
          if (!this.password) {
            this.$Toast("请输入密码！");
            return
          }
          // if (this.password.length < 8) {
          // 	this.$Toast("请检查密码长度！");
          // 	return
          // }
          let url = '/login/api/login'
          if (this.loginType === '2') {
            url = '/login/api/samlLogin'
          }
          this.$store.dispatch(this.$LoadShow, true)
          this.$post(url, JSON.stringify({
            userName: this.userName,
            password: this.password,
            verify: {
              id: this.verifyId,
              code: this.verifyCode
            }
          })).then((res) => {
            this.$store.dispatch(this.$LoadShow, false)
            if (res.success && res.data) {
              // res.data.userNames.push('test1')
              // res.data.userNames.push('test2')
              this.loginSuccess(res)
            } else {
              this.getPictureImg()
              this.$Toast(res.message || "登录失败！");
            }
          })
            .catch((err) => {
              this.$store.dispatch(this.$LoadShow, false)
              this.getPictureImg()
              console.log('login/samlLogin', err)
            });
          break;
        //验证码登录
        case '3':
          let reg = /^1[0-9]{10}$/;
          if (!this.userName) {
            this.$Toast("请输入手机号！");
            return
          }
          if (this.userName.length !== 11) {
            this.$Toast("请检查手机号长度！");
            return
          }
          if (!reg.test(this.userName)) {
            this.$Toast("请输入正确的手机号！");
            return
          }
          if (!this.password) {
            this.$Toast("请输入验证码！");
            return
          }
          if (this.password.length !== 6) {
            this.$Toast("请检查验证码长度！");
            return
          }
          this.$store.dispatch(this.$LoadShow, true)
          this.$post('/login/api/smslogin',
            JSON.stringify({
              mobile: this.userName,
              smsCode: this.password,
            })
          ).then((res) => {
            this.$store.dispatch(this.$LoadShow, false)
            if (res.success && res.data) {
              this.loginSuccess(res)
            } else {
              this.getPictureImg()
              this.$Toast(res.message || "登录失败！");
            }
          }).catch((err) => {
            this.$store.dispatch(this.$LoadShow, false)
            this.getPictureImg()
            console.log('smsLogin', err)
          });
          break;
      }
    },
    //登录成功
    loginSuccess(res) {
      if (res.data.userNames && Array.isArray(res.data.userNames) && res.data.userNames
        .length > 0) {
        this.$store.commit("changeUserNames", res.data.userNames)
        this.go("/register")
      } else {
        window.sessionStorage.clear()
        window.localStorage.setItem("LoginInfo", JSON.stringify(res.data))
        window.localStorage.setItem("Identity_Token", res.data.token)
        this.$store.commit("changeLoginInfo", res.data)
        this.$store.commit("changeLoginToken", res.data.token)
        this.$store.commit("changeReLogin", '1')
        this.$Toast("登录成功！")
        //测试环境配置
        //this.$router.replace('/home')
        //return
        if (res.data.homeUrl) {
          window.localStorage.setItem("HomeUrl", res.data.homeUrl)
          this.$store.commit("changeHomeUrl", res.data.homeUrl)
          this.$router.replace(res.data.homeUrl)
        } else {
          this.$router.replace('/home')
        }
      }
    },
    //跳转注册
    register() {
      this.go("/register")
    },
    //跳转忘记密码
    forgot() {
      this.go("/forgot")
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  // font-size: 0.7rem;
  height: 100vh;
  background-size: 100vw 100vh;
  padding-top: 4rem;
  background: linear-gradient(
    180deg,
    rgba(2, 119, 252, 1) 0%,
    rgba(2, 119, 252, 1) 0%,
    rgba(255, 255, 255, 1) 22%,
    rgba(255, 255, 255, 1) 100%
  );
  border: none;
  border-radius: 0px;
  box-shadow: none;
  display: flex;
  flex-direction: column;

  .top {
    // text-align: center;
    margin: 5rem 0 0 1rem;
  }

  .sign {
    margin-top: 1rem;
    text-align: center;
    padding: 0 5%;
    position: relative;
    font-size: 14px;

    .focus1 {
      border-bottom: 1px solid rgba(81, 104, 244, 1) !important;
    }

    .forgot {
      color: #0277fc;
      position: absolute;
      top: 0;
      right: 0;
    }

    .forgot:active {
      color: #013360;
    }

    button {
      display: inline-block;
      width: 100%;
      line-height: 2.2rem;
      margin-top: 0.5rem;
      border-radius: 5px;
      color: #fff;
      //background-color: rgba(81, 104, 244, 0.3);
    }

    .dlu:active {
      background-color: #0161b8;
    }

    .dlu {
      background-color: #0277fc;
    }

    .signdiv {
      border-bottom: 1px solid #ccc;
      height: 3rem;
      display: flex;
      align-items: flex-end;
      padding-bottom: 0.1rem;
      position: relative;

      // input {
      // 	width: 100%;
      // 	height: 1.5rem;
      // 	padding-left: .3rem;
      // }

      // span {
      // 	white-space: nowrap;
      // 	line-height: 1.2rem;
      // 	display: inline-block;
      // 	font-size: 0.65rem;
      // 	color: #0277FC;
      // }

      // .timer {
      // 	color: #0277FC;
      // }
    }
  }

  .buttonBottom {
    border: 0;
    display: block;
    margin-top: 1rem;
    text-align: center;
    padding: 0 5%;
    position: relative;
    font-size: 12px;

    .left {
      color: #0277fc;
      float: left;
    }

    .left:active {
      color: #013360;
    }

    .right {
      color: #0277fc;
      float: right;
    }

    .right:active {
      color: #013360;
    }
  }

  .password {
    display: flex;
    justify-content: space-between;
  }

  //修改输入框左右padding
  ::v-deep .van-cell {
    padding: 10px 0.3rem;
  }
}
</style>